import React, { useEffect } from "react";

import { SHOP } from "../config";

// Reservio ships a script that upgrades the placeholder div into a booking
// button. It only scans the DOM on load, so the script is (re)appended when
// this component mounts.
const ReservioButton = ({ text = "Vytvořit rezervaci" }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.reservio.com/widget/button-bundle.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div
      className="reservio-button-container"
      data-text={text}
      data-size="large"
      data-color="#77a02e"
      data-url={SHOP.reservio}
    />
  );
};

export default ReservioButton;
